import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import { Box } from '@chakra-ui/react'

const Carousel = ({ children, theme, dataTestId }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: theme.autoplaySpeed || 7000,
    arrows: false
  }

  return (
    <>
      <Box boxShadow="site" className="box-carousal">
        <Slider {...settings}>{children}</Slider>
      </Box>
      <style jsx global>
        {`
          .box-carousal .slick-dots li button:before {
            font-size: 12px;
          }
        `}
      </style>
    </>
  )
}

Carousel.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string.isRequired
}

export default Carousel
